import { makeObservable, observable, reaction, runInAction } from "mobx";
import { User } from "oidc-client-ts";
import { AcxStore } from "stores/RootStore";
import type { IRootStore } from "stores/RootStore";
import { DashboardDomain } from "../../../../models/Dashboard/DashboardDefinition";
import { AuthStore } from "../../../../stores/AuthStore";
import { BaseStore } from "../../../../stores/BaseStore";
import { OrgSelectorComponentStore } from "../../../../stores/ComponentStores/OrgSelectorComponentStore";
import { DashboardStore } from "../../../../stores/Layout/DashboardStore";

@AcxStore
export class LandingDashboardStore extends BaseStore {
    readonly dashboardStore: DashboardStore;
    readonly orgSelectorComponentStore: OrgSelectorComponentStore =
        new OrgSelectorComponentStore();
    readonly authStore: AuthStore;

    @observable private user?: User | null;

    constructor(private rootStore: IRootStore) {
        super("Landing Dashboard");

        makeObservable(this);

        this.dashboardStore = new DashboardStore(
            rootStore,
            DashboardDomain.Landing,
        );

        this.authStore = rootStore.getStore(AuthStore);

        rootStore
            .getStore(AuthStore)
            .getUserObject()
            .then((value) => {
                runInAction(() => {
                    this.user = value;
                });
            })
            .catch((reason) =>
                console.error(`Failed to retrieve User Profile ${reason}`),
            );

        reaction(
            (r) => ({
                orgSelectId: this.authStore.orgStore?.selectedOrganization?.id,
                user: this.user,
                activeLocation: this.rootStore.activeLocation,
            }),
            (arg) => {
                if (
                    arg.activeLocation.location &&
                    arg.activeLocation.location !==
                        "/app/signals/reports/home" &&
                    arg.activeLocation.location !==
                        "/app/signals/reporting/home" &&
                    arg.activeLocation.location !== "/app/signals/reports" &&
                    arg.activeLocation.location !== "/app/signals/reporting"
                ) {
                    return;
                }
                if (!arg.orgSelectId && this.user) {
                    this.dashboardStore.initializeStoreParameters(
                        this.user?.profile?.OrgId,
                        this.user,
                    );
                } else if (arg.user && arg.orgSelectId) {
                    const orgId = arg.orgSelectId;
                    this.dashboardStore.initializeStoreParameters(
                        orgId!,
                        arg.user,
                    );
                }
            },
            { fireImmediately: true, delay: 4000 },
        );

        reaction(
            (r) => ({
                selectedOrganization:
                    this.rootStore.getStore(AuthStore).orgStore
                        ?.selectedOrganization,
            }),
            (arg) => {
                this.orgSelectorComponentStore.selectOrg(
                    arg.selectedOrganization,
                );
            },
            { fireImmediately: true },
        );
    }
}
